import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import Api from '../../../utils/api';
import Toaster from '../../Toaster/Index';
import { LeftPanel } from '../../Wrappers';
import { sendAmplitudeEvents, updatePluginList } from '../../../utils/helper';
import { EventNames } from '../../../utils/events';
import { LTButton, LTFormControl, LTLoader, LTRadio, LTText } from '@lambdatestincprivate/lt-components';
import LTTextInput from '@lambdatestincprivate/lt-components/lib/components/LTInputBox';
import { Link } from '@primer/react';
import Icons from '../../../assets/images';
import { setInstructionState } from '../../../redux/features/configSlice';

const docLink = `${process.env.REACT_APP_DOC_URL}/taiga-integration`;

export default function Taiga() {
    const dispatch = useDispatch();
    const sideBarObject: any = useSelector(
        (state: RootState) => state.config.sideBarObject
    );
    const [isLoading, setIsLoading] = useState(false);
    const [isgettingData, setIsGettingData] = useState(false);
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [host, setHost] = useState('');
    const [errors, setErrors] = useState({});

    const [isCloud, setIsCloud] = useState(true);
    const isInstalled = sideBarObject.is_installed;

    useEffect(() => {
        const fetchPluginInfo = async () => {
            if (isInstalled) {
                setIsGettingData(true);
                try {
                    const res = await Api.commonApi.getPluginInfo(sideBarObject.code);
                    if (res.data) {
                        const data = res.data;
                        if (data.INSTALLED==="YES" && data.PROCESSING==="SUCCESS"){
                            setUserName(data.USERNAME || '');
                            if (data.IS_CLOUD.toLowerCase() === "true") {
                                setIsCloud(true);
                            } else {
                                setIsCloud(false);
                            }
                            setHost(data.HOST || '');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching plugin info:', error);
                } finally {
                    setIsGettingData(false);
                }
            }
        };

        fetchPluginInfo();
    }, [isInstalled, sideBarObject.code]);


    const install = async (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        setIsLoading(true);
        setErrors({});
        sendAmplitudeEvents(EventNames.INT_CLICK_INSTALL, {
            category: sideBarObject.category,
            plugin_name: sideBarObject.name,
        });
        try {
            const res = await Api.installApi.apiInstall(sideBarObject.code, {
                "USERNAME":username,
                "PASSWORD":password,
                "HOST":host,
                "IS_CLOUD":isCloud
            });
            if (res.message) {
                Toaster.success(res.message);
            }
            await updatePluginList();
            setIsLoading(false);
        } catch (err: any) {
            setIsLoading(false);
            if (err.response.data.errors) {
                setErrors(err.response.data.errors);
            } else {
                Toaster.error(err.response.data.message);
            }
        }
    };
    
    return (
        <LeftPanel>
            {isgettingData ?(
                <div className='flex flex-col items-center justify-center h-full space-y-4 mb-4'>
               <LTLoader
					heading={`Loading ...`}
					size='large'
					containerStyles={{ height: 'auto' }}
				/>
                </div>
            ):(
                <>
            <div role="radiogroup" aria-labelledby="instanceTypeLabel"  className='flex flex-col space-y-2 mb-4'>
                            <label className={`text-xs font-semibold`} aria-hidden id="instanceTypeLabel">Taiga instance type</label>
                            <LTRadio
                                type='radio'
                                name='taigaInstanceType'
                                aria-label='Cloud'
                                checked={isCloud === true}
                                value='Cloud'
                                readOnly
                                onClick={() => {
                                    setIsCloud(true);
                                    dispatch(
                                        setInstructionState(
                                            'Instructions'
                                        )
                                    );
                                }}
                                label='Cloud'
                                shouldHighlightLabel={true}
                            />
                            <LTRadio
                                type='radio'
                                name='taigaInstanceType'
                                aria-label='Self Hosted'
                                checked={isCloud !== true}
                                value='SelfHosted'
                                readOnly
                                onClick={() => {
                                    setIsCloud(false);
                                    dispatch(
                                        setInstructionState(
                                            'Instructions(SelfHosted)'
                                        )
                                    );
                                }}
                                label='Self Hosted'
                                shouldHighlightLabel={true}
                            />
                    </div>
            <form
                action=''
                className='flex flex-col space-y-4'
                id='form1'
                onSubmit={install}
            >
                {isCloud === false && (
                <LTFormControl
                    label='Taiga Hosted URL'
                    labelStyle={{
                        fontSize: 12,
                    }}
                    formStyles={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    <LTTextInput
                        inputOnly={true}
                        type='text'
                        id='hostedurl'
                        aria-label='HostedUrl'
                        width={'100%'}
                        contrast
                        placeholder=''
                        onChange={(value :any) => setHost(value)}
                        trailingAction={() => setHost('')}
                        value={host}
                        required
                    />
                </LTFormControl>
                )}
                <LTFormControl
                    label='Username'
                    labelStyle={{
                        fontSize: 12,
                    }}
                    formStyles={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    <LTTextInput
                        inputOnly={true}
                        type='text'
                        id='username'
                        aria-label='username'
                        width={'100%'}
                        contrast
                        placeholder=''
                        onChange={(value :any) => setUserName(value)}
                        trailingAction={() => setUserName('')}
                        value={username}
                        required
                    />
                    {(errors as any).apikey && (
                        <small className='w-full h-2.5 text-[10px] text-red-600'>
                            {(errors as any).apikey && (errors as any).apikey[0]}
                        </small>
                    )}
                </LTFormControl>
                <LTFormControl
                    label='Password'
                    labelStyle={{
                        fontSize: 12,
                    }}
                    formStyles={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    <LTTextInput
                        inputOnly={true}
                        type='password'
                        id='password'
                        aria-label='password'
                        width={'100%'}
                        contrast
                        placeholder=''
                        onChange={(value :any) => setPassword(value)}
                        trailingAction={() => setPassword('')}
                        value={password}
                        required
                    />
                    {(errors as any).apikey && (
                        <small className='w-full h-2.5 text-[10px] text-red-600'>
                            {(errors as any).apisecret && (errors as any).apisecret[0]}
                        </small>
                    )}
                </LTFormControl>
                <LTButton
                    variant={LTButton.Variant.PRIMARY}
                    disabled={isLoading}
                    onClick={install}
                    className='self-start'
                >
                    {isInstalled?"Re-sync":"Install"}
                </LTButton>
            </form>
            <div className='grid inline-block min-[686px]:absolute min-[686px]:bottom-0 max-[685px]:mt-[16px] mb-[16px]'>
                <LTText color={"muted"}
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    lineHeight: "16px",
                    color: '#666666'
                  }}>Know how to integrate taiga</LTText>
                <Link
					className='focus-black'
                    href={docLink}
                    target='_blank'
                    rel='noreferrer'
                >
                    Taiga Integration Guide
                </Link>
            </div>
            </>
            )}
        </LeftPanel>
    );
}
